import { useQuery } from "urql";
import { graphql } from "../../gql";
import { SongbookUb } from "../../gql/graphql";

export function useSongbooksQuery(): {
  songbooks: readonly SongbookUb[];
  fetching: boolean;
} {
  const [result] = useQuery({
    query: songbooksQuery,
  });

  const { data, fetching } = result;

  return {
    songbooks: data?.songbooks ?? [],
    fetching,
  };
}

const songbooksQuery = graphql(`
  query songbooksQuery {
    songbooks {
      id
      bucket
      mnemonic
      name
    }
  }
`);
